import React from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { Form, Input, Button, Modal, Alert } from 'antd';

import apiPath from 'apiPath';
import withSpin from 'components/withSpin';
import SaveButton from 'components/SaveButton';
import stickyError from 'components/stickyError';

import { formItemLayout, tailFormItemLayout } from './formItemLayout.js';

class SendPasswordSet extends React.Component {
	state = { sent: null }
	handleSubmit = (event) => {
		event.preventDefault();
		this.props.isSubmitting();
		this.props.form.validateFields((error, values) => {
			if (error) {
				this.props.isSubmitted();
				console.error(error);
				return stickyError('Invalid input');
			} else {
				axios.post(apiPath+'/auth/requestReset', values, {withCredentials: true})
					.then(result => {
						this.props.isSubmitted();
						this.setState({ sent: true })
					})
					.catch(error => {
						this.props.isSubmitted();
						stickyError('An error occurred while sending your request')
					});
			}
		});
	}
	render() {
		const { getFieldDecorator } = this.props.form;
		return(
			<div>
				<Alert showIcon type="warning" message={<strong style={{fontSize:'1.2em'}}>If you are unsure which email address you used</strong>}
					description={
						<p className="withSpacing">
							<Link to="/forgotemail"><Button type="danger">Click here to get a hint</Button></Link>
						</p>
					} />
				<legend>Enter your email address</legend>
				<Modal title="An email has been sent to this address if there is an account linked to it"
					visible={this.state.sent !== null} closable={false}
					footer={[ <Button onClick={() => this.setState({ sent: null })}>Close</Button> ]}>
					Please allow 5-10 minutes for the email to come through and check your spam folder just in case.
					<br /><br />
					<p>If you're still having trouble, email <a href="mailto:techsupport@semesteratsea.org">techsupport@semesteratsea.org</a>.</p>
				</Modal>
				<Form onSubmit={this.handleSubmit}>
					<Form.Item label="Email Address" {...formItemLayout}>
						{getFieldDecorator('Email', {
							rules: [
								{required: true, message: 'Email address is required'},
								{type: 'email', message: 'Please enter a valid email address'}
							],
							validateTrigger: ['onBlur']
						})(
							<Input />
						)}
					</Form.Item>
					<SaveButton noAlign icon="mail"
						buttonText="Send Password Reset Link"
						formItemLayout={tailFormItemLayout}
						loading={this.props.getStatus().submitting} />
				</Form>
			</div>
		);
	}
}

export default withSpin(Form.create()(SendPasswordSet));



// WEBPACK FOOTER //
// ./src/containers/Login/SendPasswordSet.jsx